import type { TalentRepresentationFormValues } from "./types";

export const TALENT_REPRESENTATION_FORM_DEFAULTS: TalentRepresentationFormValues = {
  talentName: "",
  representativeName: "",
  representativeEmail: "",
  talentSocialLinks: "",
  shortBio: "",
};

export const fieldConfig = {
  talentName: {
    name: "talentName" as const,
    required: true,
  },
  representativeName: {
    name: "representativeName" as const,
    required: true,
  },
  representativeEmail: {
    name: "representativeEmail" as const,
    required: true,
  },
  talentSocialLinks: {
    name: "talentSocialLinks" as const,
    required: false,
  },
  shortBio: {
    name: "shortBio" as const,
    required: false,
  },
};
